"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAppStateSelector_1 = __importDefault(require("../hooks/useAppStateSelector"));
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const appStateSelectControlExistById_1 = __importDefault(require("../shared/appStateSelectControlExistById"));
const appStateSelectControlTagById_1 = __importDefault(require("../shared/appStateSelectControlTagById"));
const Controls_1 = require("../types/Controls");
const ControlStripeCardFieldComponent_1 = __importDefault(require("./ControlStripeCardFieldComponent"));
const AppRenderControl = ({ controlId, }) => {
    const { Render, renderControl } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const controlExist = (0, useAppStateSelector_1.default)((0, appStateSelectControlExistById_1.default)(controlId));
    const controlTag = (0, useAppStateSelector_1.default)((0, appStateSelectControlTagById_1.default)(controlId));
    if (!controlExist) {
        react_1.default.createElement(Render.ControlNotFound, { controlId: controlId });
    }
    if (!controlTag) {
        return (react_1.default.createElement(Render.View, null,
            react_1.default.createElement(Render.Text, null, "Tag not found")));
    }
    switch (controlTag) {
        case Controls_1.ControlTag.stripeCardField:
            return renderControl({
                controlId,
                renderControl: () => (react_1.default.createElement(ControlStripeCardFieldComponent_1.default, { controlId: controlId })),
            });
        default:
            return (react_1.default.createElement(Render.View, null,
                react_1.default.createElement(Render.Text, null, `Invalid tag: ${controlTag}`)));
    }
};
exports.default = AppRenderControl;
